var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundTransList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735899327847,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4988,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148 110m57.9 0l312.2 0q57.9 0 57.9 57.9l0 684.2q0 57.9-57.9 57.9l-312.2 0q-57.9 0-57.9-57.9l0-684.2q0-57.9 57.9-57.9Z",
    fill: "#495057",
    "p-id": 4989
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.14 191.16m8 0l365.72 0q8 0 8 8l0 592.7q0 8-8 8l-365.72 0q-8 0-8-8l0-592.7q0-8 8-8Z",
    fill: "#F1F3F5",
    "p-id": 4990
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.94 138.98m11.58 0l80.94 0q11.58 0 11.58 11.58l0 0.02q0 11.58-11.58 11.58l-80.94 0q-11.58 0-11.58-11.58l0-0.02q0-11.58 11.58-11.58Z",
    fill: "#868E96",
    "p-id": 4991
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M333.08 827.4m28.92 0l0 0q28.92 0 28.92 28.92l0 0.14q0 28.92-28.92 28.92l0 0q-28.92 0-28.92-28.92l0-0.14q0-28.92 28.92-28.92Z",
    fill: "#868E96",
    "p-id": 4992
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.018213 531.569683m11.518933-0.156823l80.312557-1.093408q11.518933-0.156823 11.675756 11.362109l0.000544 0.039996q0.156823 11.518933-11.362109 11.675756l-80.312557 1.093408q-11.518933 0.156823-11.675756-11.362109l-0.000544-0.039996q-0.156823-11.518933 11.362109-11.675756Z",
    fill: "#96F2D7",
    "p-id": 4993
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.825766 474.667274m11.518932-0.156823l114.769365-1.562517q11.518933-0.156823 11.675756 11.362109l0.000544 0.039996q0.156823 11.518933-11.362109 11.675756l-114.769364 1.562517q-11.518933 0.156823-11.675756-11.362109l-0.000545-0.039996q-0.156823-11.518933 11.362109-11.675756Z",
    fill: "#63E6BE",
    "p-id": 4994
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M349.72 360m34.54 0l459.2 0q34.54 0 34.54 34.54l0 230.92q0 34.54-34.54 34.54l-459.2 0q-34.54 0-34.54-34.54l0-230.92q0-34.54 34.54-34.54Z",
    fill: "#20C997",
    "p-id": 4995
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M794.22 622.5H433.5a46 46 0 0 0-46-46v-132.96a46 46 0 0 0 46-46h360.72a46 46 0 0 0 46 46v132.9a46 46 0 0 0-46 46.06z",
    fill: "#63E6BE",
    "p-id": 4996
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M613.117339 562.195217a52.02 52.24 0.78 1 0 1.422302-104.470318 52.02 52.24 0.78 1 0-1.422302 104.470318Z",
    fill: "#20C997",
    "p-id": 4997
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundTransList);
export default __webpack_public_path__ + "static/media/fundTransList.4442b3f511b6ec7e77ced95441f87df1.svg";
export { ForwardRef as ReactComponent };